export const hyphenateCarlineId = (carlineId: string): string => {
	switch (carlineId.toLowerCase()) {
		case 'q8etron':
			return 'q8-e-tron';
		case 'q8sbetron':
			return 'q8-sportback-e-tron';
		case 'sq8etron':
			return 'sq8-e-tron';
		case 'sq8sbetron':
			return 'sq8-sportback-e-tron';
		case 'q6etron':
			return 'q6-e-tron';
		case 'sq6etron':
			return 'sq6-e-tron';
		case 'q4etron':
			return 'q4-e-tron';
		case 'q4sbetron':
			return 'q4-sportback-e-tron';
		default:
			return carlineId;
	}
};

export const hyphenateModelLine = (carlineId: string): string => {
	// Required for tracking
	switch (carlineId.toLowerCase()) {
		case 'q8etron':
		case 'q8sbetron':
		case 'sq8etron':
		case 'sq8sbetron':
			return 'q8-e-tron';
		case 'sq6etron':
		case 'q6etron':
			return 'q6-e-tron';
		case 'q4etron':
		case 'q4sbetron':
			return 'q4-e-tron';

		default:
			return carlineId;
	}
};
